import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);  // Close sidebar after navigation

  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed top-4 left-4 z-50 p-2 border-4 border-black hover:bg-[#a4f700] 
          transition-all duration-400 ease-in-out
        ${isOpen ? 'translate-x-64' : 'translate-x-0'}`}
        aria-label="Toggle Menu"
      >
        {isOpen ? 'Close' : 'Menu'}
      </button>


      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full w-64 bg-white border-r-4 border-black shadow-lg
          transform transition-transform duration-300 ease-in-out z-40
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <h1 className="syne-heavy-gradienttext-4xl font-bold m-6 border-b-4 border-black pb-4">
          Yago Torres
        </h1>

        {/* Navigation Links */}
        <nav className="flex flex-col space-y-4 mx-6">
          <Link 
            to="/" 
            onClick={closeMenu}
            className="text-xl font-bold border-b-2 border-black pb-2 hover:bg-black hover:text-white transition-colors"
          >
            Home
          </Link>
          <Link 
            to="/about" 
            onClick={closeMenu}
            className="text-xl font-bold border-b-2 border-black pb-2 hover:bg-black hover:text-white transition-colors"
          >
            About
          </Link>
          <Link 
            to="/projects" 
            onClick={closeMenu}
            className="text-xl font-bold border-b-2 border-black pb-2 hover:bg-black hover:text-white transition-colors"
          >
            Projects
          </Link>
          <Link 
            to="/contact" 
            onClick={closeMenu}
            className="text-xl font-bold border-b-2 border-black pb-2 hover:bg-black hover:text-white transition-colors"
          >
            Contact
          </Link>
        </nav>
      </aside>
    </>
  );
};

export default Header;
